import { render, staticRenderFns } from "./CopyCampaignDialog.vue?vue&type=template&id=5b7b8ea9&"
import script from "./CopyCampaignDialog.vue?vue&type=script&lang=js&"
export * from "./CopyCampaignDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports